import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DateFormat, DateFormatService } from '@lx/shared/i18n';
import { CodeAndName } from '@lx/shared/types';
import { getDateFromString } from '@lx/shared/utils';
import { FormFieldSelectorComponent } from '../form-field-selector/form-field-selector.component';

@Component({
  standalone: true,
  selector: 'lx-date-list-selector',
  templateUrl: './date-list-selector.component.html',
  styleUrls: ['./date-list-selector.component.scss'],
  imports: [CommonModule, FormFieldSelectorComponent],
})
export class DateListSelectorComponent implements OnInit, OnChanges {
  @Input() value: string | undefined;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() disabled = false;
  @Input() required = false;
  @Input() iconValidation = false;
  @Input() dates: string[] = [];
  @Output() valueChange = new EventEmitter<string>();

  protected dataSource: CodeAndName[] = [];

  private readonly dateFormatService = inject(DateFormatService);

  ngOnInit(): void {
    this.initializeData();
  }

  ngOnChanges({ dates, value }: SimpleChanges): void {
    if (dates || value) {
      this.initializeData();
    }
  }

  protected handleDateSelected(dateString: string): void {
    this.valueChange.emit(dateString);
  }

  private initializeData(): void {
    if (!this.dates?.length) {
      this.dataSource = [];
      return;
    }

    // Remove duplicates
    const uniqueDates = [...new Set(this.dates.filter((dateString) => Boolean(dateString)))];

    // Transform to CodeAndName format required by form-field-selector
    this.dataSource = uniqueDates.map((dateString) => ({
      code: dateString,
      name: this.dateFormatService.formatDate(getDateFromString(dateString), DateFormat.SHORT_MONTH_NAME),
    }));
  }
}
